import { useEffect, useState } from 'react';
import { setEmissionData } from '../lib/emissions';

// Module-level cache so we only fetch once per session and share across mounts.
let _cache = null;

/**
 * Fetches the active DB-backed emission factors + the full region×vintage sets
 * and loads them into the shared emissions engine so client-side math uses the
 * correct per-region factor VALUES + labels (US, UK, EU, CA, AU) instead of a
 * flat US EPA default. Returns { version, loaded, factors, sources }. Include
 * `version` in a useMemo dep list to recompute after factors load. Public
 * endpoint — plain fetch (no auth) so it also works on the trial viewer.
 */
export function useEmissionFactors() {
  const [state, setState] = useState(
    _cache || { version: 0, loaded: false, factors: null, sources: null },
  );

  useEffect(() => {
    if (_cache && _cache.loaded) return undefined;
    let alive = true;
    const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
    fetch(`${base}/api/emission-factors/active`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive || !d || !d.factors) return;
        setEmissionData({ factors: d.factors, regions: d.regions });
        _cache = { version: d.version || 1, loaded: true, factors: d.factors, sources: d.sources };
        setState(_cache);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return state;
}

export default useEmissionFactors;
